import { useState, useEffect } from "react";
import { useApp, api } from "../context";
import { Shell, Btn, TierBadge, EmptyState } from "../components";

const BODY_TYPES = [{v:"Petite",d:"Small/slender frame"},{v:"Slim",d:"Lean build"},{v:"Slim Thick",d:"Slim with curves"},{v:"Thick",d:"Full/curvy figure"},{v:"BBW",d:"Big beautiful curves"},{v:"Athletic",d:"Fit/toned body"},{v:"Any",d:"No preference"}];
const PURPOSES = [{v:"Meetup",d:"Casual meet & greet"},{v:"Threesome",d:"3-person encounter"},{v:"Trip/Travel",d:"Travel together"},{v:"Accompaniment",d:"Be my plus-one"},{v:"Fun",d:"No-strings fun"},{v:"For Me & Partner",d:"Couple seeking third"},{v:"Casual Hangout",d:"Chill & vibe"},{v:"Date",d:"Romantic date"},{v:"Party Partner",d:"Club/event buddy"}];
const COMPENSATION_OPTS = [{v:"",d:"Not specified"},{v:"All bills covered",d:"I pay everything"},{v:"Split bills",d:"We share costs"},{v:"Token/Appreciation",d:"Financial gift included"},{v:"No compensation",d:"Just vibes"}];
const DURATION_TYPES = [{v:"one_time",l:"One-time"},{v:"weekend",l:"Weekend"},{v:"ongoing",l:"Ongoing"},{v:"trip",l:"Trip"}];
const GENDERS = ["Male","Female","Trans","Non-Binary","Couple","All Genders"];
const SEXUALITIES = ["Straight","Bisexual","Gay","Lesbian","Pansexual","Queer","Open","Other"];
const REL_STATUSES = ["Single","Dating","Married","Exploring","Open Relationship","It's Complicated"];
const KENYA_COUNTIES = ["Nairobi","Mombasa","Kisumu","Nakuru","Kiambu","Uasin Gishu","Machakos","Kajiado","Kilifi","Nyeri","Murang'a","Meru","Laikipia","Kwale","Taita Taveta","Lamu","Garissa","Marsabit","Turkana","Trans Nzoia","Bungoma","Busia","Kakamega","Siaya","Homa Bay","Migori","Kisii","Nyamira","Kirinyaga","Embu","Kitui","Makueni","Narok","Kericho","Bomet","Nandi","Baringo"];

const BlueTick = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" style={{ display: "inline-block", verticalAlign: "middle", marginLeft: 2 }}>
    <path d="M12 1L9.5 3.5H5.5L4 5.5V9.5L1 12L4 14.5V18.5L5.5 20.5H9.5L12 23L14.5 20.5H18.5L20 18.5V14.5L23 12L20 9.5V5.5L18.5 3.5H14.5L12 1Z" fill="#3b82f6"/>
    <path d="M10 15.5L7 12.5L8.4 11.1L10 12.7L15.6 7.1L17 8.5L10 15.5Z" fill="white"/>
  </svg>
);

const Tag = ({ label, desc, color, icon }) => {
  const { c } = useApp();
  return (
    <span title={desc} style={{ padding: "4px 10px", borderRadius: 10, background: `${color}12`, border: `1px solid ${color}25`, color: color, fontSize: 10, fontWeight: 600, cursor: desc ? "help" : "default", display: "inline-flex", alignItems: "center", gap: 3 }}>
      {icon && <span style={{ fontSize: 10 }}>{icon}</span>}{label}
    </span>
  );
};

const MeetupCard = ({ m, onInterest, isOwn, onFound, onClose, onViewInterests }) => {
  const { c, go, setViewingUser } = useApp();
  const u = m.user || {};
  const isCompleted = ["found", "expired", "closed"].includes(m.status);
  const hasInterested = m.my_interest;
  const purposeDesc = PURPOSES.find(p => p.v === m.purpose)?.d || "";
  const bodyDesc = BODY_TYPES.find(b => b.v === m.body_type)?.d || "";
  return (
    <div style={{ background: c.card, borderRadius: 16, border: `1px solid ${isCompleted ? "#10b98130" : c.border}`, padding: 16, marginBottom: 10, position: "relative" }}>
      {isCompleted && <div style={{ position: "absolute", top: 12, right: 12, padding: "3px 10px", borderRadius: 8, background: "#10b98118", color: "#10b981", fontSize: 10, fontWeight: 700 }}>COMPLETED</div>}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
        <div onClick={() => { if (!isOwn && u.id) { setViewingUser(u.id); go("user_profile"); } }} style={{ cursor: isOwn ? "default" : "pointer", display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
          {u.avatar_url ? <img src={u.avatar_url} style={{ width: 42, height: 42, borderRadius: 21, objectFit: "cover" }} alt="" /> :
            <div style={{ width: 42, height: 42, borderRadius: 21, background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{u.avatar_emoji || "👤"}</div>}
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: c.text }}>{u.name} <TierBadge plan={u.plan} verified={u.is_verified} size={12} /></div>
            <div style={{ fontSize: 10, color: c.faint, display: "flex", alignItems: "center", gap: 4 }}>
              {u.age ? `${u.age}yrs` : ""} {u.gender || ""} · Trust: {u.trust_score || 0}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
          <BlueTick />
          <span style={{ fontSize: 9, color: "#3b82f6", fontWeight: 600 }}>Verified</span>
        </div>
      </div>
      <p style={{ fontSize: 13, color: c.text, margin: "0 0 12px", lineHeight: 1.6 }}>{m.description}</p>
      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 12 }}>
        <Tag label={m.purpose} desc={purposeDesc} color="#6c5ce7" icon="🎯" />
        <Tag label={`Age ${m.age_min}-${m.age_max}`} color="#f59e0b" icon="📅" />
        {m.body_type && m.body_type !== "Any" && <Tag label={m.body_type} desc={bodyDesc} color="#ef4444" icon="✨" />}
        {m.gender_pref && <Tag label={m.gender_pref} color="#8b5cf6" icon="👤" />}
        {m.sexuality_pref && <Tag label={m.sexuality_pref} color="#ec4899" icon="💜" />}
        <Tag label={m.location} color="#10b981" icon="📍" />
        {m.compensation && <Tag label={m.compensation} desc={COMPENSATION_OPTS.find(co => co.v === m.compensation)?.d} color="#8b5cf6" icon="💰" />}
        {m.meeting_date && <Tag label={new Date(m.meeting_date).toLocaleDateString("en-GB", { weekday: "short", month: "short", day: "numeric" }) + (m.meeting_time ? ` · ${m.meeting_time}` : "")} color="#06b6d4" icon="📆" />}
        {m.rel_status && <Tag label={m.rel_status} color="#f472b6" icon="💍" />}
        <Tag label={DURATION_TYPES.find(d => d.v === m.duration_type)?.l || m.duration_type} color="#64748b" icon="⏱" />
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 11, color: c.sub, fontWeight: 600 }}>{m.interests_count || m.interest_count || 0} interested</span>
          {(() => { const target = m.meeting_date || m.expires_at; if (!target) return null; const days = Math.ceil((new Date(target) - new Date()) / 86400000); if (days < 0) return <span style={{ fontSize: 9, padding: "2px 6px", borderRadius: 6, background: "#ef444415", color: "#ef4444", fontWeight: 700 }}>Expired</span>; if (days === 0) return <span style={{ fontSize: 9, padding: "2px 6px", borderRadius: 6, background: "#f59e0b15", color: "#f59e0b", fontWeight: 700 }}>Today!</span>; if (days <= 7) return <span style={{ fontSize: 9, padding: "2px 6px", borderRadius: 6, background: "#10b98115", color: "#10b981", fontWeight: 700 }}>{days}d left</span>; return null; })()}
        </div>
        {isOwn ? (
          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={onViewInterests} style={{ padding: "7px 14px", borderRadius: 10, border: `1px solid ${c.pri}`, background: "transparent", color: c.pri, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>View ({m.interests_count || m.interest_count || 0})</button>
            {m.status === "active" && <button onClick={onFound} style={{ padding: "7px 14px", borderRadius: 10, border: "none", background: "#10b98118", color: "#10b981", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Mark Completed</button>}
            {m.status === "active" && onClose && <button onClick={onClose} style={{ padding: "7px 12px", borderRadius: 10, border: "none", background: "#ef444412", color: "#ef4444", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Close</button>}
          </div>
        ) : (
          !isCompleted && (
            hasInterested
              ? <div style={{ display: "flex", alignItems: "center", gap: 6 }}><span style={{ padding: "7px 14px", borderRadius: 10, fontSize: 11, fontWeight: 700, background: hasInterested === "accepted" ? "#10b98112" : hasInterested === "declined" ? "#ef444412" : "#f59e0b12", color: hasInterested === "accepted" ? "#10b981" : hasInterested === "declined" ? "#ef4444" : "#f59e0b" }}>{hasInterested === "accepted" ? "✓ Accepted" : hasInterested === "declined" ? "✗ Declined" : "⏳ Interest Sent"}</span>{hasInterested === "accepted" && <button onClick={(e) => { e.stopPropagation(); if (u.id) { setViewingUser(u.id); go("user_profile"); } }} style={{ padding: "7px 14px", borderRadius: 10, border: "none", background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", color: "#fff", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>💬 Message</button>}</div>
              : <button onClick={onInterest} style={{ padding: "8px 20px", borderRadius: 10, border: "none", background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>I'm Interested</button>
          )
        )}
      </div>
    </div>
  );
};

export const MeetupsPage = () => {
  const { c, go, user, flash, setViewingUser } = useApp();
  const [tab, setTab] = useState("browse");
  const [data, setData] = useState({ requests: { data: [] }, found: [], my_requests: [] });
  const [showCompose, setShowCompose] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [viewingInterests, setViewingInterests] = useState(null);
  const [interests, setInterests] = useState([]);
  const [filters, setFilters] = useState({ purpose: "", location: "", body_type: "", gender: "" });
  const [form, setForm] = useState({ description: "", age_min: 18, age_max: 45, body_type: "Any", purpose: "Meetup", location: "", compensation: "", duration_type: "one_time", meeting_date: "", meeting_time: "", gender_pref: "", sexuality_pref: "", rel_status: "" });
  const [loading, setLoading] = useState(true);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const load = async () => { setLoading(true); const r = await api("/meetups"); if (r.ok) setData(r.data); setLoading(false); };
  useEffect(() => { load(); }, []);

  const postMeetup = async () => {
    if (!form.description || form.description.length < 10) { flash("Describe what you're looking for (min 10 chars)", "error"); return; }
    if (!form.location) { flash("Select a location", "error"); return; }
    const r = await api("/meetups", { method: "POST", body: JSON.stringify(form) });
    if (r.ok) { flash("Meetup request posted!"); setShowCompose(false); load(); setTab("mine"); }
    else { if (r.data?.verify_required) setShowVerifyModal(true); else flash(r.data?.message || "Failed", "error"); }
  };

  const sendInterest = async (id) => {
    const r = await api(`/meetups/${id}/interest`, { method: "POST" });
    if (r.ok) { flash("Interest sent! They'll be notified"); load(); }
    else { if (r.data?.verify_required) setShowVerifyModal(true); else if (r.data?.upgrade_required) setShowUpgradeModal(true); else flash(r.data?.message || "Failed", "error"); }
  };

  const markFound = async (id) => { const r = await api(`/meetups/${id}/found`, { method: "POST" }); if (r.ok) { flash("Marked as completed!"); load(); } };
  const closeMeetup = async (id) => { if (!confirm("Close this request? It will be removed from browse.")) return; const r = await api(`/meetups/${id}/close`, { method: "POST" }); if (r.ok) { flash("Request closed"); load(); } };

  const loadInterests = async (id) => {
    setViewingInterests(id);
    const r = await api(`/meetups/${id}/interests`);
    if (r.ok) setInterests(r.data || []);
  };

  const respondInterest = async (intId, status) => {
    const r = await api(`/meetup-interests/${intId}/respond`, { method: "POST", body: JSON.stringify({ status }) });
    if (r.ok) { flash(status === "accepted" ? "Accepted! They can message you" : "Declined"); loadInterests(viewingInterests); }
  };

  // Apply filters
  const filtered = (data.requests?.data || []).filter(m => {
    if (filters.purpose && m.purpose !== filters.purpose) return false;
    if (filters.location && m.location !== filters.location) return false;
    if (filters.body_type && m.body_type !== filters.body_type && filters.body_type !== "Any") return false;
    if (filters.gender && m.gender_pref && m.gender_pref !== filters.gender) return false;
    return true;
  });

  const S = {
    inp: { width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid ${c.border}`, background: c.input, color: c.text, fontSize: 13, outline: "none", boxSizing: "border-box", fontFamily: "'DM Sans',sans-serif" },
    lbl: { display: "block", fontSize: 10, fontWeight: 700, color: c.sub, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.5 },
    row: { display: "flex", gap: 8, marginBottom: 10 },
  };

  
  // Verify Modal
  const VerifyModal = () => showVerifyModal ? (
    <div style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setShowVerifyModal(false)}>
      <div onClick={e => e.stopPropagation()} style={{ background: c.card, borderRadius: 20, padding: "28px 24px", maxWidth: 360, width: "100%", textAlign: "center", border: `1px solid ${c.border}`, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ width: 64, height: 64, borderRadius: 32, background: "linear-gradient(135deg, #3b82f615, #6c5ce715)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
          <svg width="32" height="32" viewBox="0 0 24 24"><path d="M12 1L9.5 3.5H5.5L4 5.5V9.5L1 12L4 14.5V18.5L5.5 20.5H9.5L12 23L14.5 20.5H18.5L20 18.5V14.5L23 12L20 9.5V5.5L18.5 3.5H14.5L12 1Z" fill="#3b82f6"/><path d="M10 15.5L7 12.5L8.4 11.1L10 12.7L15.6 7.1L17 8.5L10 15.5Z" fill="white"/></svg>
        </div>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: c.text, margin: "0 0 8px" }}>Verification Required</h3>
        <p style={{ fontSize: 13, color: c.sub, margin: "0 0 6px", lineHeight: 1.5 }}>For everyone's safety, only verified accounts can post meetup requests and express interest.</p>
        <p style={{ fontSize: 12, color: c.faint, margin: "0 0 20px", lineHeight: 1.4 }}>Verification takes less than 5 minutes. Just share your social media handles and send 2-3 photos via WhatsApp.</p>
        <button onClick={() => { setShowVerifyModal(false); if (typeof window !== "undefined") sessionStorage.setItem("gc_settings_tab", "security"); go("settings"); }} style={{ width: "100%", padding: "13px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg, #3b82f6, #6c5ce7)", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 8 }}>Verify Now</button>
        <button onClick={() => setShowVerifyModal(false)} style={{ width: "100%", padding: "11px 0", borderRadius: 12, border: `1px solid ${c.border}`, background: "transparent", color: c.sub, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Maybe Later</button>
      </div>
    </div>
  ) : null;

  // Upgrade Modal
  const UpgradeModal = () => showUpgradeModal ? (
    <div style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setShowUpgradeModal(false)}>
      <div onClick={e => e.stopPropagation()} style={{ background: c.card, borderRadius: 20, padding: "28px 24px", maxWidth: 360, width: "100%", textAlign: "center", border: `1px solid ${c.border}`, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ width: 64, height: 64, borderRadius: 32, background: "linear-gradient(135deg, #f59e0b15, #6c5ce715)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 32 }}>👑</div>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: c.text, margin: "0 0 8px" }}>Upgrade Your Plan</h3>
        <p style={{ fontSize: 13, color: c.sub, margin: "0 0 6px", lineHeight: 1.5 }}>Free verified accounts can express interest up to 3 times per month.</p>
        <p style={{ fontSize: 12, color: c.faint, margin: "0 0 20px", lineHeight: 1.4 }}>Upgrade to Premium or Elite for unlimited interactions, messaging, and exclusive features.</p>
        <button onClick={() => { setShowUpgradeModal(false); go("premium"); }} style={{ width: "100%", padding: "13px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 8 }}>Upgrade Now</button>
        <button onClick={() => setShowUpgradeModal(false)} style={{ width: "100%", padding: "11px 0", borderRadius: 12, border: `1px solid ${c.border}`, background: "transparent", color: c.sub, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Maybe Later</button>
      </div>
    </div>
  ) : null;

  // Interests view
  if (viewingInterests) return (
    <Shell title="People Interested" showBack onBack={() => setViewingInterests(null)}>
      <div style={{ padding: "10px 0" }}>
        {interests.length === 0 ? <EmptyState icon="👥" title="No one yet" desc="Share your request to get more interest" /> :
          interests.map(int => (
            <div key={int.id} style={{ background: c.card, borderRadius: 14, border: `1px solid ${c.border}`, padding: 14, marginBottom: 8 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div onClick={() => { setViewingUser(int.user?.id); setViewingInterests(null); go("user_profile"); }} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", flex: 1 }}>
                  {int.user?.avatar_url ? <img src={int.user.avatar_url} style={{ width: 44, height: 44, borderRadius: 22, objectFit: "cover" }} alt="" /> :
                    <div style={{ width: 44, height: 44, borderRadius: 22, background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>{int.user?.avatar_emoji || "👤"}</div>}
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: c.text }}>{int.user?.name} <TierBadge plan={int.user?.plan} verified={int.user?.is_verified} size={12} /></div>
                    <div style={{ fontSize: 11, color: c.faint }}>{int.user?.age ? `${int.user.age}yrs` : ""} {int.user?.gender || ""} · Trust: {int.user?.trust_score || 0}</div>
                    {int.user?.bio && <div style={{ fontSize: 11, color: c.sub, marginTop: 3 }}>{int.user.bio.slice(0, 80)}</div>}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 5, flexShrink: 0 }}>
                  {int.status === "pending" ? <>
                    <button onClick={() => respondInterest(int.id, "accepted")} style={{ padding: "7px 12px", borderRadius: 8, border: "none", background: "#10b98118", color: "#10b981", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Accept</button>
                    <button onClick={() => respondInterest(int.id, "declined")} style={{ padding: "7px 12px", borderRadius: 8, border: "none", background: "#ef444412", color: "#ef4444", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Decline</button>
                  </> : <span style={{ fontSize: 11, fontWeight: 700, color: int.status === "accepted" ? "#10b981" : "#ef4444", padding: "7px 12px", borderRadius: 8, background: int.status === "accepted" ? "#10b98112" : "#ef444412" }}>{int.status === "accepted" ? "✓ Accepted" : "✗ Declined"}</span>}
                </div>
              </div>
            </div>
          ))}
      </div>
    </Shell>
  );

  return (
    <Shell title="Meetup Requests" showBack onBack={() => go("feed")}><VerifyModal /><UpgradeModal />
      <div style={{ padding: "10px 0" }}>
        {/* Verified banner */}
        <div style={{ background: "linear-gradient(135deg, #3b82f608, #10b98108)", borderRadius: 12, padding: "10px 14px", marginBottom: 12, border: "1px solid #3b82f620", display: "flex", alignItems: "center", gap: 8 }}>
          <BlueTick />
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#3b82f6" }}>Verified Community</div>
            <div style={{ fontSize: 10, color: c.sub }}>All posts are from verified accounts. Your safety matters.</div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
          {[{ id: "browse", label: "Browse", icon: "🔍" }, { id: "mine", label: "My Posts", icon: "📝" }, { id: "found", label: "Completed", icon: "✅" }].map(tb => (
            <button key={tb.id} onClick={() => setTab(tb.id)}
              style={{ flex: 1, padding: "9px 0", borderRadius: 10, border: `1.5px solid ${tab === tb.id ? c.pri : c.border}`, background: tab === tb.id ? c.priBg : c.card, color: tab === tb.id ? c.priTxt : c.sub, fontSize: 12, fontWeight: 700, cursor: "pointer", textAlign: "center" }}>
              {tb.icon} {tb.label}
            </button>
          ))}
        </div>

        {/* Post button */}
        {!showCompose && tab === "browse" && <button onClick={() => setShowCompose(true)} style={{ width: "100%", padding: "12px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg, #6c5ce7, #a23ad1)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", marginBottom: 10, letterSpacing: 0.3 }}>+ Post a Meetup Request</button>}

        {/* Compose form */}
        {showCompose && (
          <div style={{ background: c.card, borderRadius: 16, border: `1px solid ${c.border}`, padding: 18, marginBottom: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: c.text }}>New Meetup Request</span>
              <button onClick={() => setShowCompose(false)} style={{ background: "none", border: "none", color: c.sub, cursor: "pointer", fontSize: 18 }}>✕</button>
            </div>

            <label style={S.lbl}>DESCRIBE WHAT YOU'RE LOOKING FOR</label>
            <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="e.g. Looking for a 25-30yo lady, petite, for a fun weekend in Nairobi. All bills covered..." style={{ ...S.inp, height: 85, resize: "none", marginBottom: 10, lineHeight: 1.5 }} />

            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>PREFERRED GENDER</label>
                <select value={form.gender_pref} onChange={e => setForm({ ...form, gender_pref: e.target.value })} style={S.inp}>
                  <option value="">Any Gender</option>{GENDERS.map(g => <option key={g} value={g}>{g}</option>)}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>PREFERRED SEXUALITY</label>
                <select value={form.sexuality_pref} onChange={e => setForm({ ...form, sexuality_pref: e.target.value })} style={S.inp}>
                  <option value="">Any</option>{SEXUALITIES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>

            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>AGE RANGE</label>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                  <input type="number" min={18} max={99} value={form.age_min} onChange={e => setForm({ ...form, age_min: parseInt(e.target.value) || 18 })} style={{ ...S.inp, textAlign: "center" }} />
                  <span style={{ fontSize: 11, color: c.sub, flexShrink: 0 }}>to</span>
                  <input type="number" min={18} max={99} value={form.age_max} onChange={e => setForm({ ...form, age_max: parseInt(e.target.value) || 50 })} style={{ ...S.inp, textAlign: "center" }} />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>BODY TYPE PREFERENCE</label>
                <select value={form.body_type} onChange={e => setForm({ ...form, body_type: e.target.value })} style={S.inp}>
                  {BODY_TYPES.map(b => <option key={b.v} value={b.v}>{b.v} — {b.d}</option>)}
                </select>
              </div>
            </div>

            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>PURPOSE</label>
                <select value={form.purpose} onChange={e => setForm({ ...form, purpose: e.target.value })} style={S.inp}>
                  {PURPOSES.map(p => <option key={p.v} value={p.v}>{p.v} — {p.d}</option>)}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>YOUR STATUS</label>
                <select value={form.rel_status} onChange={e => setForm({ ...form, rel_status: e.target.value })} style={S.inp}>
                  <option value="">Prefer not to say</option>{REL_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>

            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>LOCATION / COUNTY</label>
                <select value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} style={S.inp}>
                  <option value="">Select County</option>{KENYA_COUNTIES.map(co => <option key={co} value={co}>{co}</option>)}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>COMPENSATION</label>
                <select value={form.compensation} onChange={e => setForm({ ...form, compensation: e.target.value })} style={S.inp}>
                  {COMPENSATION_OPTS.map(co => <option key={co.v} value={co.v}>{co.v || "Not specified"} {co.d ? `— ${co.d}` : ""}</option>)}
                </select>
              </div>
            </div>

            <div style={S.row}>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>MEETING DATE</label>
                <input type="date" value={form.meeting_date} onChange={e => setForm({ ...form, meeting_date: e.target.value })} min={new Date().toISOString().split("T")[0]} style={S.inp} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={S.lbl}>TIME OF DAY</label>
                <select value={form.meeting_time} onChange={e => setForm({ ...form, meeting_time: e.target.value })} style={S.inp}>
                  <option value="">Flexible</option><option value="Morning">Morning</option><option value="Afternoon">Afternoon</option><option value="Evening">Evening</option><option value="Night">Night</option><option value="All Day">All Day</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={S.lbl}>DURATION</label>
              <div style={{ display: "flex", gap: 6 }}>
                {DURATION_TYPES.map(d => (
                  <button key={d.v} onClick={() => setForm({ ...form, duration_type: d.v })}
                    style={{ flex: 1, padding: "8px 0", borderRadius: 10, border: `1.5px solid ${form.duration_type === d.v ? c.pri : c.border}`, background: form.duration_type === d.v ? c.priBg : c.input, color: form.duration_type === d.v ? c.priTxt : c.sub, fontSize: 11, fontWeight: 700, cursor: "pointer", textAlign: "center" }}>{d.l}</button>
                ))}
              </div>
            </div>

            <Btn primary full onClick={postMeetup}>Post Request</Btn>
          </div>
        )}

        {/* Filter section */}
        {tab === "browse" && !showCompose && (
          <>
            <button onClick={() => setShowFilters(!showFilters)} style={{ width: "100%", padding: "8px 0", borderRadius: 10, border: `1px dashed ${c.border}`, background: "transparent", color: c.sub, fontSize: 12, fontWeight: 600, cursor: "pointer", marginBottom: 10 }}>
              {showFilters ? "Hide Filters ▲" : `Filter Results ▼ ${Object.values(filters).filter(Boolean).length > 0 ? `(${Object.values(filters).filter(Boolean).length} active)` : ""}`}
            </button>
            {showFilters && (
              <div style={{ background: c.card, borderRadius: 14, border: `1px solid ${c.border}`, padding: 14, marginBottom: 12 }}>
                <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                  <div style={{ flex: 1 }}>
                    <label style={S.lbl}>PURPOSE</label>
                    <select value={filters.purpose} onChange={e => setFilters({ ...filters, purpose: e.target.value })} style={S.inp}>
                      <option value="">All Purposes</option>{PURPOSES.map(p => <option key={p.v} value={p.v}>{p.v}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={S.lbl}>LOCATION</label>
                    <select value={filters.location} onChange={e => setFilters({ ...filters, location: e.target.value })} style={S.inp}>
                      <option value="">All Locations</option>{KENYA_COUNTIES.map(co => <option key={co} value={co}>{co}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <div style={{ flex: 1 }}>
                    <label style={S.lbl}>BODY TYPE</label>
                    <select value={filters.body_type} onChange={e => setFilters({ ...filters, body_type: e.target.value })} style={S.inp}>
                      <option value="">Any</option>{BODY_TYPES.map(b => <option key={b.v} value={b.v}>{b.v}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={S.lbl}>GENDER</label>
                    <select value={filters.gender} onChange={e => setFilters({ ...filters, gender: e.target.value })} style={S.inp}>
                      <option value="">All</option>{GENDERS.map(g => <option key={g} value={g}>{g}</option>)}
                    </select>
                  </div>
                </div>
                {Object.values(filters).some(Boolean) && (
                  <button onClick={() => setFilters({ purpose: "", location: "", body_type: "", gender: "" })} style={{ width: "100%", marginTop: 8, padding: "7px 0", borderRadius: 8, border: "none", background: "#ef444412", color: "#ef4444", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Clear Filters</button>
                )}
              </div>
            )}
          </>
        )}

        {/* Browse */}
        {tab === "browse" && (
          loading ? <div style={{ textAlign: "center", padding: 30, color: c.sub }}>Loading...</div> :
          filtered.length > 0 ? filtered.map(m => <MeetupCard key={m.id} m={m} onInterest={() => sendInterest(m.id)} />) :
          <EmptyState icon="🤝" title="No meetup requests yet" desc="Be the first to post what you're looking for!" />
        )}

        {/* My posts */}
        {tab === "mine" && (
          data.my_requests?.length > 0 ? data.my_requests.map(m => <MeetupCard key={m.id} m={m} isOwn onFound={() => markFound(m.id)} onClose={() => closeMeetup(m.id)} onViewInterests={() => loadInterests(m.id)} />) :
          <EmptyState icon="📝" title="No requests yet" desc="Post a meetup request to get started!" />
        )}

        {/* Completed */}
        {tab === "found" && (
          [...(data.found||[]), ...(data.my_requests||[]).filter(m => ["expired","closed"].includes(m.status))].length > 0
          ? [...(data.found||[]), ...(data.my_requests||[]).filter(m => ["expired","closed"].includes(m.status))].map(m => <MeetupCard key={m.id} m={m} />)
          : <EmptyState icon="✅" title="No completed meetups yet" desc="Completed meetups will appear here" />
        )}
      </div>
    </Shell>
  );
};
